import { makeStyles } from '@material-ui/core';
import constants from '../../../abstracts/constants';
import { scienceBlue, alabaster, cherry, abbey } from '../../../abstracts/colours';
import styled from 'styled-components';
import { small } from '../../../abstracts/spacing';

interface Props {
  isOpen: boolean;
}

const useStyles = makeStyles({
  paper: {
    margin: '8px 0',
    boxShadow:
      '0 1px 14px 0 rgba(206, 212, 217, 0.12), 0 5px 8px 0 rgba(206, 212, 217, 0.14), 0 3px 5px -1px rgba(206, 212, 217, 0.2)',
    borderRadius: '10px',
    '& .MuiPickersDay-daySelected': {
      backgroundColor: scienceBlue,
    },
    '& .MuiPickersCalendarHeader-iconButton:not([disabled])': {
      color: scienceBlue,
    },
    '& .MuiPickersCalendar-transitionContainer': {
      marginBottom: '12px',
    },
    '& .MuiPickersDay-current': {
      color: scienceBlue,
      '& p': {
        fontWeight: 'bold',
      },
    },
    '& .MuiPickersDay-current.MuiPickersDay-daySelected': {
      color: alabaster,
      '& p': {
        fontWeight: 'normal',
      },
    },
  },
  input: {
    fontSize: 20,
    height: 64,
    fontFamily: constants.sourceSansPro,
    borderColor: scienceBlue,
    borderWidth: '2px',
    '&.MuiOutlinedInput-adornedEnd': {
      paddingRight: 4,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: scienceBlue,
      borderWidth: '2px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: scienceBlue,
      borderWidth: '2px',
    },
    '&.Mui-disabled': {
      backgroundColor: alabaster,
      borderRadius: '10px',
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: alabaster,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderColor: (props: Props): string => (props.isOpen ? scienceBlue : '#ced4d9'),
      borderRadius: '10px',
    },
    '& .MuiSvgIcon-root': {
      color: scienceBlue,
    },
    '& .MuiIconButton-root.Mui-disabled .MuiSvgIcon-root': {
      color: '#ced4d9',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: scienceBlue,
      borderWidth: '2px',
    },
  },
});

export const ErrorMsg = styled.div`
  color: ${cherry};
  margin-left: ${small};
  font-family: ${constants.sourceSansPro};
  font-size: ${constants.SMALL};
`;

export const HelperText = styled.div`
  font-family: ${constants.sourceSansPro};
  font-size: ${constants.SMALL};
  color: ${abbey};
  margin-left: ${small};
`;

export default useStyles;
